import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=2b2bb45f&scoped=true&"
import script from "./Selector.vue?vue&type=script&lang=js&"
export * from "./Selector.vue?vue&type=script&lang=js&"
import style0 from "./Selector.vue?vue&type=style&index=0&id=2b2bb45f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2bb45f",
  null
  
)

export default component.exports